module.exports = __webpack_public_path__ + "../resources/img/new_inventory.5ced6744.png";